import React from 'react';

import { LottieSvg } from 'lottie-react';

import styles from './AnimatedIconSuccess.module.css';
import successAnimation from '@/static/lottie/success.json';

export const AnimatedIconSuccess: React.FC = () => (
    <div className={styles.animatedIconSuccess} data-testid="animated-icon-success-div">
        <LottieSvg src={successAnimation} loop={false} autoplay />
    </div>
);
